<script>
import WhitelabelFileTypes from "@/enums/WhitelabelFileTypes";

export default {
  data() {
    return {
      maxUploadSize: 1024 * 1024,
      allowedFileTypes: ['image/png', 'image/svg+xml', 'image/webp', 'image/x-icon'],
      logoLightFile: null,
      previewLogoLightUrl: '/assets/logos/fp/logo_navbar.png',
      logoDarkFile: null,
      previewLogoDarkUrl: '/assets/logos/fp/logo_navbar.png',
    }
  },
  computed: {
    WhitelabelFileTypes() {
      return WhitelabelFileTypes
    },
    logoLight() {
      return this.$store.state?.whitelabel?.logos?.light;
    },
    logoDark() {
      return this.$store.state?.whitelabel?.logos?.dark;
    }
  },
  created() {
    this.$store.dispatch('getLightLogo');
    this.$store.dispatch('getDarkLogo');
  },
  methods: {
    onHandleLogoUpload(file, type) {
      if (!file) return;

      if (!this.allowedFileTypes.includes(file.type)) return;

      if (file.size > this.maxUploadSize) {
        this.$notify(this.$t('component.whitelabel.custom.logos.upload.file.too.large'), {type: 'error'});
        return;
      }

      const objectUrl = URL.createObjectURL(file);

      if (type === WhitelabelFileTypes.LightLogo) {
        this.logoLightFile = file;
        this.previewLogoLightUrl = objectUrl;
      } else if (type === WhitelabelFileTypes.DarkLogo) {
        this.logoDarkFile = file;
        this.previewLogoDarkUrl = objectUrl;
      }

      this.$store.dispatch('putLogo', {type, file})
      .then(() => {
        this.$store.dispatch(type === WhitelabelFileTypes.LightLogo ? 'getLightLogo' : 'getDarkLogo');
        this.logoLightFile = null;
        this.logoDarkFile = null;
      })

    },
    resetLogos() {
      this.logoLightFile = null
      this.previewLogoLightUrl = '/assets/logos/fp/logo_navbar.png'
      this.logoDarkFile = null
      this.previewLogoDarkUrl = '/assets/logos/fp/logo_navbar.png'
    }
  }
}
</script>

<template>
  <v-container fluid class="pt-0">
    <!--    HEADER-->
    <v-row class="pt-0">
      <v-col class="pt-0">
        <h3 class="float-left">{{ $t('component.whitelabel.custom.logos.heading') }}</h3>
        <v-tooltip top>
          <template #activator="{ on }">
            <v-btn id="reset-default-logos-button" class="float-right" icon color="primary" v-on="on" @click="resetLogos">
              <v-icon>mdi-autorenew</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('component.whitelabel.custom.logos.reset.button.tooltip') }}</span>
        </v-tooltip>
      </v-col>
    </v-row>

    <v-divider></v-divider>

    <!-- LIGHT LOGO -->
    <v-row id="custom-light-logo-container" class="mt-4">
      <v-col>
        <v-card
          outlined
          elevation="2"
          class="pa-4"
          style="cursor: pointer;"
          :disabled="!$store.getters.urls.subdomain"
          @click="$refs.lightFileInput.click()">
          <v-card-title class="d-flex justify-space-between align-center">
            <div class="d-flex align-center">
              <h4 class="text-subtitle-1 font-weight-bold me-2">
                {{ $t('component.whitelabel.custom.logos.light.logo.header') }}
              </h4>
            </div>
          </v-card-title>
          <v-card-text class="text-center">
            <img
              :src="logoLightFile ? previewLogoLightUrl : logoLight || previewLogoLightUrl"
              alt="Logo Hell Vorschau"
              height="120"
              class="my-4"/>
            <input
              id="light-logo-file-input"
              ref="lightFileInput"
              type="file"
              accept=".ico,.png,.webp,.svg"
              style="display: none;"
              @change="(event)=>onHandleLogoUpload(event.target.files[0],WhitelabelFileTypes.LightLogo)"/>
            <div v-if="logoLightFile" class="mt-2">
              <div>{{ logoLightFile.name }}</div>
              <div class="text-caption">
                {{ (logoLightFile.size / 1024).toFixed(2) }} KB
              </div>
            </div>
            <div v-else class="text-caption mt-2">
              {{ $t('component.whitelabel.custom.logos.upload.hint') }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- DARK LOGO -->
    <v-row id="custom-dark-logo-container" class="mt-4">
      <v-col>
        <v-card
          outlined
          elevation="2"
          class="pa-4"
          color="#252525"
          style="cursor: pointer;"
          :disabled="!$store.getters.urls.subdomain"
          @click="$refs.darkFileInput.click()">
          <v-card-title class="d-flex justify-space-between align-center">
            <div class="d-flex align-center">
              <h4 class="text-subtitle-1 font-weight-bold me-2 white--text">
                {{ $t('component.whitelabel.custom.logos.dark.logo.header') }}
              </h4>
            </div>
          </v-card-title>
          <v-card-text class="text-center">
            <img
              :src="logoDarkFile ? previewLogoDarkUrl : logoDark || previewLogoDarkUrl"
              alt="Logo Dunkel Vorschau"
              height="120"
              class="my-4"/>
            <input
              id="dark-logo-file-input"
              ref="darkFileInput"
              type="file"
              accept=".ico,.png,.webp,.svg"
              style="display: none;"
              @change="(event)=>onHandleLogoUpload(event.target.files[0],WhitelabelFileTypes.DarkLogo)"/>
            <div v-if="logoDarkFile" class="white--text mt-2">
              <div>{{ logoDarkFile.name }}</div>
              <div class="text-caption">
                {{ (logoDarkFile.size / 1024).toFixed(2) }} KB
              </div>
            </div>
            <div v-else class="white--text text-caption mt-2">
              {{ $t('component.whitelabel.custom.logos.upload.hint') }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

  </v-container>
</template>
